import type { CannedResponseSummary } from '@livechat/shared';

export interface SlashTrigger {
	end: number;
	query: string;
	start: number;
}

export function isCannedSelectionKey(key: string): boolean {
	return key === 'Enter' || key === 'Tab';
}

export function findSlashTrigger(value: string, cursor: number): SlashTrigger | undefined {
	const beforeCursor = value.slice(0, cursor);
	const match = /(?:^|\s)\/([^\s/]*)$/.exec(beforeCursor);
	if (!match) return undefined;
	const query = match[1] ?? '';
	return { end: cursor, query, start: cursor - query.length - 1 };
}

export function filterCannedResponses(
	responses: CannedResponseSummary[],
	query: string,
): CannedResponseSummary[] {
	const needle = query.trim().toLowerCase();
	return responses
		.filter((response) => response.status === 'active')
		.filter(
			(response) =>
				!needle ||
				response.name.toLowerCase().includes(needle) ||
				response.trigger?.toLowerCase().includes(needle) ||
				response.body.toLowerCase().includes(needle),
		)
		.sort((left, right) => {
			if (left.scope !== right.scope) return left.scope === 'company' ? -1 : 1;
			return left.name.localeCompare(right.name) || left.id.localeCompare(right.id);
		});
}

export function insertCannedResponse(
	value: string,
	body: string,
	selectionStart: number,
	selectionEnd: number,
	slashTrigger?: SlashTrigger,
): { cursor: number; value: string } {
	const start = slashTrigger?.start ?? selectionStart;
	const end = slashTrigger?.end ?? selectionEnd;
	const trailingSpace = value[end] && !/\s/.test(value[end]) && !/\s$/.test(body) ? ' ' : '';
	return {
		cursor: start + body.length,
		value: `${value.slice(0, start)}${body}${trailingSpace}${value.slice(end)}`,
	};
}
